import { render, staticRenderFns } from "./my-training.vue?vue&type=template&id=810de0fe&"
import script from "./my-training.vue?vue&type=script&lang=tsx&"
export * from "./my-training.vue?vue&type=script&lang=tsx&"
import style0 from "./my-training.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports